module.exports = __webpack_public_path__ + "img/property-img.f1edccd2.jpg";